import React from 'react';
import { Tbody, Tr, Td, Box } from '@chakra-ui/react';
import { flexRender } from '@tanstack/react-table';
import { SetCellTemplate, NestedData, IndeterminateCheckbox, ExpandRowButton } from './utils/table-utils.js';
import { i18n } from '../../../i18n/translate.js';
var CoreTableRows = function CoreTableRows(_ref) {
  var columns = _ref.columns,
    noDataIndication = _ref.noDataIndication,
    onRowClick = _ref.onRowClick,
    select = _ref.select,
    table = _ref.table,
    dataListProps = _ref.dataListProps;
  var rowPadding = {
    paddingLeft: 0 // initialize padding to be dynamically adjusted later based on nesting order
  };
  var noDataText = noDataIndication || i18n.t('There is no data to display.'); // similar to foundry's bootstrap table feature
  var areRowsClickable = !select && typeof onRowClick === 'function';
  var handleRowClick = function handleRowClick(event, row) {
    if (!areRowsClickable) return;
    onRowClick(event, row);
  };
  var isLoadingData = dataListProps.isLoadingData,
    selectRow = dataListProps.selectRow;

  /**
   * DOM
   */
  return /*#__PURE__*/React.createElement(Tbody, null, table.getRowModel().rows.length < 1 ? /*#__PURE__*/React.createElement(Tr, null, /*#__PURE__*/React.createElement(Td, {
    colSpan: columns.length
  }, isLoadingData ? i18n.t('Loading...') : noDataText)) : table.getRowModel().rows.map(function (row, rowIndex) {
    /**
     * DOM - Row
     */
    var keyRow = "row-".concat(JSON.stringify(row), "-").concat(rowIndex);
    return /*#__PURE__*/React.createElement(Tr, {
      key: keyRow,
      verticalAlign: "initial",
      onClick: function onClick(event) {
        return handleRowClick(event, row.original);
      },
      "data-object-id": row.original.id ? row.original.id : row.id,
      cursor: areRowsClickable ? 'pointer' : 'auto'
    }, row.getVisibleCells().map(function (cell, cellIndex) {
      var _document$getElementB, _cell$column$columnDe;
      /**
       * DOM - cell
       */
      var keyCell = "row-cell-".concat(cell.id.toString(), "-").concat(cellIndex);
      var content = flexRender(cell.column.columnDef.cell, cell.getContext());
      var cellRow = row.original[cell.column.id];
      var cellContent;
      if (cellRow || cellRow === 0) {
        cellContent = cellRow[cellIndex];
        if (typeof cellRow === 'string' || typeof cellRow === 'number') {
          cellContent = row.original[cell.column.id];
        }
        if (typeof row.original[cell.column.id] === 'function') {
          cellContent = row.original[cell.column.id](row);
        }
      }
      // if present, render cell template over content
      if (columns[cellIndex].cellTemplate) {
        cellContent = SetCellTemplate(columns[cellIndex], row.original, cellIndex, cell.column.id);
      }
      var parentPadding = parseInt((_document$getElementB = document.getElementById("".concat(row.parentId, "-content"))) === null || _document$getElementB === void 0 || (_document$getElementB = _document$getElementB.style) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.paddingLeft);
      var expandedData = row.original.expandedData;
      var shouldFitContent = !!((_cell$column$columnDe = cell.column.columnDef) !== null && _cell$column$columnDe !== void 0 && _cell$column$columnDe.fitContent);
      var cellWidth = shouldFitContent ? '100%' : undefined;
      return /*#__PURE__*/React.createElement(Td, {
        key: keyCell,
        "data-attribute": cell.column.id
      }, cellIndex === 0 && expandedData ? /*#__PURE__*/React.createElement(NestedData, {
        expandedData: expandedData,
        content: content
      }) : /*#__PURE__*/React.createElement(Box, {
        id: "".concat(row.id, "-content"),
        style: row.parentId && cellIndex === 0 ? {
          paddingLeft: 30 + parentPadding
        } : rowPadding,
        display: "inline-flex",
        alignSelf: "baseline",
        alignItems: "center",
        width: cellWidth
      }, cellIndex === 0 && select ? /*#__PURE__*/React.createElement(IndeterminateCheckbox, {
        checked: row.getIsSelected(),
        disabled: !row.getCanSelect(),
        indeterminate: row.getIsSomeSelected(),
        onChange: row.getToggleSelectedHandler(),
        isLoadingData: isLoadingData,
        selectHandler: selectRow === null || selectRow === void 0 ? void 0 : selectRow.onSelect,
        selectedProp: row.original
      }) : '', cellIndex === 0 && row.getCanExpand() ? /*#__PURE__*/React.createElement(ExpandRowButton, {
        toggleExpand: row.getToggleExpandedHandler(),
        isExpanded: row.getIsExpanded()
      }) : '', /*#__PURE__*/React.createElement(Box, {
        width: cellWidth
      }, cellContent)));
    }));
  }));
};
CoreTableRows.displayName = "CoreTableRows";
export { CoreTableRows };